@if (loading) {
  <p-skeleton width="100%" height="300px"></p-skeleton>
} @else {
  <p-tree
    [value]="tree"
    selectionMode="checkbox"
    class="w-full"
    [(selection)]="selection"
    (selectionChange)="handleSelectionChange()"
  ></p-tree>
}
